import { DataLayer } from '@grandvisionhq/analytics';
import { Locales } from '@grandvisionhq/state';
import { mapOfferingToOfferingSelectionEvent, mapOfferingToAddToCartEvent } from './Mappers/OfferingMapper.js';
import { mapProductToDataLayerProductObject } from './Mappers/ProductMapper.js';

const pushPdpEventToDataLayer = (purchaseType, product, activeSku, currency, productType, pricePerMonth)=>{
    pushEventToDataLayer(purchaseType, product, activeSku, currency, {
        list: 'pdp'
    }, 'gvProductDetail', productType, pricePerMonth);
};
const pushEventToDataLayer = (purchaseType, product, activeSku, currency, actionField, dataEvent, productType, pricePerMonth, eventType, offering)=>{
    const productObject = mapProductToDataLayerProductObject(purchaseType, product, activeSku, // Data in the Data Layer should always be English, therefore hardcoded locale
    Locales['en-GB'], productType, pricePerMonth, offering);
    if (!productObject) {
        return;
    }
    DataLayer.pushEcommerceEvent({
        event: dataEvent,
        atfEcommerce: {
            ecommerce: {
                currencyCode: currency,
                [eventType || 'detail']: {
                    actionField,
                    products: [
                        productObject
                    ]
                }
            }
        }
    });
};
const pushTabClickEvent = (isCLBBTabSelected)=>{
    DataLayer.pushEvent({
        event: 'ContactLensesConfigEvent',
        eventAction: 'click on tab',
        eventLabel: isCLBBTabSelected ? DataLayer.DataLayerTypes.PurchaseType.CLBBSubscription : DataLayer.DataLayerTypes.PurchaseType.OneTime
    });
};
function pushOfferingSelectionEvent(offering, { isDefaultSelection =false  } = {}) {
    DataLayer.pushEvent(mapOfferingToOfferingSelectionEvent(offering, {
        isDefaultSelection
    }));
}
function pushAddToCartEvent(product, activeSku, offering, currency) {
    DataLayer.pushEvent(mapOfferingToAddToCartEvent(offering));
    pushEventToDataLayer(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, activeSku, currency, {}, 'gvAddToCart', DataLayer.DataLayerTypes.LineItemType.Bundle, undefined, DataLayer.DataLayerTypes.EventType.add, offering);
}

export { pushAddToCartEvent, pushEventToDataLayer, pushOfferingSelectionEvent, pushPdpEventToDataLayer, pushTabClickEvent };
//# sourceMappingURL=data-layer.js.map
